module.exports = __webpack_public_path__ + "img/icon_indi_pin.9650b81d.svg";